export const actionFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Title__c: 'title',
  Date__c: 'dueDate',
  Order__c: 'order',
  Success__c: 'success',
  ExpectedOutcome__c: 'expectedOutcome',
  ActualOutcome__c: 'actualOutcome',
  ReasonOfFail__c: 'failReason',
  Description__c: 'description',
  Status__c: 'column',
  Reason__c: 'reason'
}

export interface Action {
  id: string
  title: string
  dueDate?: Date
  order: number
  success?: string
  expectedOutcome?: string
  actualOutcome?: string
  failReason?: string
  description?: string
  column: string
  reason?: string
}
